import { compose } from 'recompose';

import HistoryItemView from './HistoryItemView';

export default compose()(HistoryItemView);
